import { useState } from "react";
import RMprofileplayersmodal from "./RMprofileplayersmodal";
function Playersmodal({data, myKDName}) {
    const [rmProfileData, setRmProfileData] = useState({});
   // data.my_kd_top={}

    // console.log("data:", data);
    const [playerIndexName, setPlayerIndexName] = useState("");
    const setRmProfileDataFun = (profileData, playerIndexNameFlag) => {
        setRmProfileData(profileData);
        setPlayerIndexName(playerIndexNameFlag);
    }
    return (
        <>
            <RMprofileplayersmodal data={data} profileData={rmProfileData} playerIndexNameKey ={playerIndexName} />
            <div className="modal fade region-player-modal" tabIndex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
                aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content playersmodal">
                        <div className="team-name-box text-center mt-3">
                            <p>{myKDName}</p>
                        </div>

                        <div className="impactplayers-box">
                            <p className="text-center imptitle"><span>Impact Players</span></p>

                            <div className="imp-players-profile text-center">

                                {   
                                    data && data.my_kd_ip &&
                                    data.my_kd_ip.map((item, index) => (
                                        <div key={"my_kd_ip"+index} className="imp-players" data-toggle="modal"
                                            data-target=".rmplayersprofile-modal-lg" onClick={() => setRmProfileDataFun(item, "my_kd_ip")}>
                                            <img src={item.profile_pic} className="img-fluid ppicture"
                                             onError={(e) => {
                                                e.target.onerror = null; // Prevent infinite loop in case fallback image also fails
                                                e.target.src = "../images/BOR/avatar.jpg"; // Set fallback image
                                            }}
                                            />
                                            <p className="imp-players-name mt-1">{item.shopName}</p>
                                            
                                        </div>
                                    ))
                                }

                            </div>
                        </div>

                        <div className="distplayers-box mt-5">
                            <p className="text-center imptitle"><span>Top Distributor</span></p>

                            <div className="dist-players-profile text-center">

                                {/* {
                                    data && data.my_kd_top &&
                                    data.my_kd_top.map((item, index) => (
                                        <div  key={"my_kd_top"+index} className="dist-players">
                                            <img src={item.profile_pic} className="img-fluid ppicture" data-toggle="modal"
                                                data-target=".rmplayersprofile-modal-lg" onClick={() => setRmProfileDataFun(item, "my_kd_top")}
                                                
                                                onError={(e) => {
                                                    e.target.onerror = null; // Prevent infinite loop in case fallback image also fails
                                                    e.target.src = "../images/BOR/avatar.jpg"; // Set fallback image
                                                }}
                                                />
                                            <p className="dist-players-name mt-1">{item.shopName}</p>
                                        </div>
                                    ))
                                } */}
                                {
                                    data && data.my_kd_top &&
                                    data.my_kd_top
                                    .filter(item => item.rank <= 5)
                                    .sort((a, b) => a.rank - b.rank)
                                    .map((item, index) => (
                                        <div key={"my_kd_top" + index} className="dist-players">
                                        <img
                                            src={item.profile_pic}
                                            className="img-fluid ppicture"
                                            data-toggle="modal"
                                            data-target=".rmplayersprofile-modal-lg"
                                            onClick={() => setRmProfileDataFun(item, "my_kd_top")}
                                            onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = "../images/BOR/avatar.jpg";
                                            }}
                                        />
                                        <p className="dist-players-name mt-1">{item.shopName}</p>
                                        </div>
                                    ))
                                }
                            </div>
                            
                        </div>

                        <div className="footerclose-contaner">
                            <button type="button" className="close mb-3" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true"><img src="../images/BOR/close-button.png" className="img-fluid w-50" /></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Playersmodal;